var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { styled } from '@creditas-ui/react';
export var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
export var Menu = styled.ul(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  width: 100%;\n  box-shadow: ", ";\n  border-radius: ", ";\n  top: 70px;\n  background-color: white;\n"], ["\n  position: absolute;\n  width: 100%;\n  box-shadow: ", ";\n  border-radius: ", ";\n  top: 70px;\n  background-color: white;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.shadow.sm;
}, function (_a) {
    var theme = _a.theme;
    return theme.radius['4xl'];
});
export var Option = styled.li(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border-radius: ", ";\n  list-style: none;\n  padding: ", ";\n  background-color: white;\n  cursor: pointer;\n"], ["\n  border-radius: ", ";\n  list-style: none;\n  padding: ", ";\n  background-color: white;\n  cursor: pointer;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.radius['4xl'];
}, function (_a) {
    var theme = _a.theme;
    return "".concat(theme.spacingTop['3xl'], " ").concat(theme.spacingLeft['5xl']);
});
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Autocomplete.styles.js.map